




















































































import ReportsCompanyPicker from './ReportsCompanyPicker.vue';
import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import VehiclesForSuscription from './VehiclesForSuscription.vue';
import {
    formatList,
    getIdsFromList,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, AvailableVehiclesList, RadioOptions, RadioOption, UserCompaniesReports } from '../../../features/core/models/';
import { ReportsServices } from '../api/ReportsServices';


@Component({
    components: {
        Loading,
        Combobox,
        Button,
        SimpleTable,
        SectionTitle,
        MultipleSelect,
        VehiclesForSuscription,
        ReportsCompanyPicker
    }
})
export default class ModalReportSuscription extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default(){return []}}) templatesList: Array<Template>;
    @Prop({default: null}) suscriptionData: SuscriptionsList;
    selectedCompanies: Array<UserCompaniesReports> = [];
    patchTitle: string = 'Modificar suscripción';
    submitDefaultTitle: string = 'Generar suscripción';
    submitName: string = this.submitDefaultTitle;
    pendingAction: boolean = false;
    errorMsg: string = '';
    checkedCompanies: Array<UserCompaniesReports> = [];


    submitAction() {
        let companyIds = getIdsFromList(this.checkedCompanies);
        let templateId = this.suscriptionData['template']['template_id']
        this.pendingAction = true;
        let data:Suscription = {
            template_id: templateId,
            companies: companyIds
        }

        if(this.suscriptionData.subscriptions.id !== null){
           this.patchSuscription(data, this.suscriptionData.subscriptions.id);
        }else{
             this.postSuscription(data);
        }
    }
   

    
    get isPatch(){
        
        return false
    }


    setErrorForm(text) {
        this.errorMsg = text;
    }

    formatCompanies(value){
        return formatList(value, 'name');
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg, timeout){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: timeout
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }



    postSuscription(data: Suscription){
        ReportsServices.postSuscription(
            data,
        ).then((res) => {
            this.handleSuccessAction(res, 'Suscripción creada con éxito', 12000);
            this.updateSuscriptionsList();
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo crear la suscripción');
        }).finally(() => {
            this.pendingAction = false;
        });
    }
    patchSuscription(data:Suscription, suscriptionId){
        let self = this;
        ReportsServices.patchSuscription(
            data,
            suscriptionId
        ).then((res) => {
            this.handleSuccessAction(res, 'Suscripción modificada con éxito', 2000);
            this.updateSuscriptionsList();
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo modificar la suscripción');
        }).finally(() => {
            this.pendingAction = false;
        });
    }

    loadPatchData() {
        if(this.isPatch){
           
        }
    }

    preselectCompanies(){
        for (let index = 0; index < this.suscriptionData['companies'].length; index++) {
            const companyToSelectId = this.suscriptionData['companies'][index];
            let indexInCompaniesList = this.$_getCompanies.findIndex(item => Number(item['id']) == companyToSelectId);
            // if(indexInCompaniesList !== -1){
            //     this.selectCompany(this.$_getCompanies[indexInCompaniesList]);
            // }
        }
    }


    // get getPreselectedCompaniesIds(){
        // if(this.preselectedCompanies.length !== 0){
        //     return this.preselectedCompanies.map(function(item){
        //         return Number(item['id'])
        //     });
        // }
        // return []

    // }


    get formIsValid() {
        if(this.checkedCompanies.length === 0){
            this.setErrorForm('No hay empresas marcadas')
            return false;
        }
        return true;
    }

    resetFields(){
       
    }

    @Emit()
    closeModal() {
        this.resetFields();
    }

    @Emit()
    updateSuscriptionsList(){}

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
        });
    }
}
